import { render, staticRenderFns } from "./match_scoring.vue?vue&type=template&id=de097d8a&scoped=true&"
import script from "./match_scoring.vue?vue&type=script&lang=js&"
export * from "./match_scoring.vue?vue&type=script&lang=js&"
import style0 from "./match_scoring.vue?vue&type=style&index=0&id=de097d8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de097d8a",
  null
  
)

export default component.exports